import "./JunkRemovalOrleans.module.css";
import Header from "@/reusable_sections/Header";
import HeroOrleans from "./sections/HeroOrleans";
import IntroductionOrleansLocal from "./sections/IntroductionOrleansLocal";
import ServicesGrid from "./sections/ServicesGrid";
import WhyChooseUs from "./sections/WhyChooseUs";
import HowItWorks from "./sections/HowItWorks";
import LocalAreaOrleans from "./sections/LocalAreaOrleans";
import BeforeAfterGallery from "./sections/BeforeAfterGallery";
import FaqOrleans from "./sections/FaqOrleans";
import FinalCtaOrleans from "./sections/FinalCtaOrleans";
import Footer from "@/reusable_sections/Footer";
export default function JunkRemovalOrleansPage() {
  return <div>
      <Header />
      <HeroOrleans />
      <IntroductionOrleansLocal />
      <ServicesGrid />
      <WhyChooseUs />
      <HowItWorks />
      <LocalAreaOrleans />
      <BeforeAfterGallery />
      <FaqOrleans />
      <FinalCtaOrleans />
      <Footer />
    </div>;
}